import React from "react";
import { TextField, Card, Typography, CardContent, CardActions, Button } from "@mui/material";
import { D } from "../include";



export class Utils extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_id: "17",
      procedure_id: "300",
      session_id: "2627",
      document_id: "1300",
      date: "2026-08-01",
      latitude: "",
      longitude: "",
    };
  }  
  
 
  handleUpdateTimestamps = () => {   
    this.props.api
        .post('/ToolUpdateTimestamp', { patient_id: this.state.patient_id, date: this.state.date })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Timestamps atualizados');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao modificar o registro'));
  }
  
  handleUpdateTimestampsRestricted = () => {   
    this.props.api
        .post('/ToolUpdateTimestampRestricted', { procedure_id: this.state.procedure_id, date: this.state.date })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Timestamps atualizados');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao modificar o registro'));
  }
  
  handleUpdateTimestampsReview = () => {   
    this.props.api
        .post('/ToolUpdateTimestampReview', { session_id: this.state.session_id, document_id: this.state.document_id, date: this.state.date })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Timestamps atualizados');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao modificar o registro'));
  }
  
  handleMoveStagePatient = () => {   
    this.props.api
        .post('/ToolMoveStagePatient', { patient_id: this.state.patient_id })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Stage para Paciente realizado');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao modificar o registro'));
  }
    
    
  handleUpdateLatLong = () => {   
    this.props.api
        .post('/ToolUpdateLatLong', { patient_id: this.state.patient_id, latitude: this.state.latitude, longitude: this.state.longitude })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Latitude/Longitude atualizados');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao modificar o registro'));
  }
  
    
  render() {
    return (
      <D className="col e aF scD" style={{ padding: "2rem" }}>
        <D className="col w aF">
          <D className="row w aF" style={{ flexFlow: "wrap" }}>
            <D className="e hide-md" />

              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Atualizar created_at e updated_at</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Reflete nas tabelas: patient, emergency_alternative, legal_representative, session, answer, procedure, document</Typography>
                   <TextField label="Patient ID" variant="outlined" value={this.state.patient_id} onChange={(e) => this.setState({ patient_id: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Date" variant="outlined" value={this.state.date} onChange={(e) => this.setState({ date: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleUpdateTimestamps()}>Atualizar</Button>
                 </CardActions>  
               </Card> 
              </>
              
              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Atualizar created_at e updated_at Restrito</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Reflete apenas nas tabelas: procedure, session, answer, document</Typography>
                   <TextField label="Procedure ID" variant="outlined" value={this.state.procedure_id} onChange={(e) => this.setState({ procedure_id: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Date" variant="outlined" value={this.state.date} onChange={(e) => this.setState({ date: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleUpdateTimestampsRestricted()}>Atualizar</Button>
                 </CardActions>  
               </Card> 
              </>
              
              
              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Atualizar created_at e updated_at de Revisão</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Reflete apenas nas tabelas: session, document</Typography>
                   <TextField label="Session ID" variant="outlined" value={this.state.session_id} onChange={(e) => this.setState({ session_id: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Document ID" variant="outlined" value={this.state.document_id} onChange={(e) => this.setState({ document_id: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Date" variant="outlined" value={this.state.date} onChange={(e) => this.setState({ date: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleUpdateTimestampsReview()}>Atualizar</Button>
                 </CardActions>  
               </Card> 
              </>
              
              
              
              
              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Arquivos de Stage/ para Paciente/xx/</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Reflete nas tabelas: file</Typography>
                   <TextField label="Patient ID" variant="outlined" value={this.state.patient_id} onChange={(e) => this.setState({ patient_id: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleMoveStagePatient()}>Mover</Button>
                 </CardActions>  
               </Card> 
              </>
                           
              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Atualizar Latitude/Longitude</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Reflete na tabela: patient</Typography>
                   <TextField label="Patient ID" variant="outlined" value={this.state.patient_id} onChange={(e) => this.setState({ patient_id: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Latitude" variant="outlined" value={this.state.latitude} onChange={(e) => this.setState({ latitude: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Longitude" variant="outlined" value={this.state.longitude} onChange={(e) => this.setState({ longitude: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleUpdateLatLong()}>Atualizar</Button>
                 </CardActions>  
               </Card> 
              </>
              
              
            <D className="e hide-md" />
          </D>
        </D>
      </D>
    );
  }
}























